/**
 * @file DiagnosticsService.ts
 * @role Records small, non-sensitive release diagnostics without ever affecting gameplay.
 * @owns Safe diagnostic categories/codes and the never-throw sink wrapper.
 * @neverDoes Send player identifiers, balances, grids, requests, or error messages.
 */
import { noopLogger, type Logger } from '@core/logging/Logger';

export type DiagnosticArea = 'config' | 'assets' | 'rgs' | 'presentation';
export interface DiagnosticEvent {
  area: DiagnosticArea;
  code: string;
}
export type DiagnosticSink = (event: DiagnosticEvent) => void;

export class DiagnosticsService {
  constructor(
    private readonly sink: DiagnosticSink = () => undefined,
    private readonly logger: Logger = noopLogger,
  ) {}

  record(area: DiagnosticArea, code: string): void {
    try {
      this.logger.warn(`[diagnostics] ${area}:${code}`);
      this.sink({ area, code });
    } catch {
      // Diagnostics must be fire-and-forget and never interrupt play.
    }
  }
}
